import { lightGreen10 } from '@edulastic/colors'
import styled from 'styled-components'

export const AIFeatureContentWrapper = styled.div`
  margin-top: 20px;
`

export const Image = styled.img`
  width: 240px;
  height: 169px;
  margin: 0px 8px 10px 0px;
  border-radius: 10px;
  cursor: pointer;
`

export const TextLink = styled.div`
  cursor: pointer;
  color: ${lightGreen10};
  font-size: 12px;
  margin-right: 8px;
  font-weight: 700;
`
